<template>
  <div class="page-detail-main">
    <Spin v-if="pageLoading" fix style="z-index: 999999;" />
    <!--列表-->
    <div class="orderTable">
      <div class="mb5 row-between-flex">
        <div>
          <Button type="primary" v-if="permission.export" @click="exportHand" :disabled="exportLoading">导出</Button>
        </div>
        <div>
          <setTableColumn
            :moduleData="tableColumnData"
            buttonName="自定义仓库"
            :disabled="tableDataLoading"
            @updataColumn="updataTableColumn"
          />
        </div>
      </div>
      <Table
        highlight-row
        :loading="tableDataLoading"
        border
        :height="tableHeight"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="choseTableDataChange"
        @on-sort-change="tableSortHand"
      />
      <!-- <div class="mt5" slot="page-top">
        <Checkbox v-model="allPageStatus">所有页全选</Checkbox>
      </div> -->
      <!-- 分页 -->
      <div class="table-page">
        <div class="table-page-right">
          <Page
            :total="tableTotal"
            @on-change="pageChangeHand"
            show-total
            :page-size="pageParams.pageSize"
            show-elevator
            :current="pageParams.pageNum"
            show-sizer
            @on-page-size-change="pageSizeChangeHand"
            placement="top"
            :page-size-opts="pageArray"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api/api';
import md5 from 'blueimp-md5';
import Mixin from '@/components/mixin/common_mixin';
import setTableColumn from '@/views/productCenter/components/productCenter/setTableColumn';
import productData from '@/views/productCenter/components/productCenter/staticData/productData';
// import productMixin from '@/components/mixin/product_mixin';
// import tableMixin from '@/components/mixin/table_mixin';

const platformData = [
  { warehouseName: 'CA', md5Name: md5('FBA-CA'), warehouseId: 'CA', isYms: null, warehouseType: 999 },
  { warehouseName: 'US', md5Name: md5('FBA-US'), warehouseId: 'US', isYms: null, warehouseType: 999 },
  { warehouseName: 'MX', md5Name: md5('FBA-MX'), warehouseId: 'MX', isYms: null, warehouseType: 999 },
  { warehouseName: 'BR', md5Name: md5('FBA-BR'), warehouseId: 'BR', isYms: null, warehouseType: 999 },
  { warehouseName: 'ES', md5Name: md5('FBA-ES'), warehouseId: 'ES', isYms: null, warehouseType: 999 },
  { warehouseName: 'UK', md5Name: md5('FBA-UK'), warehouseId: 'UK', isYms: null, warehouseType: 999 },
  { warehouseName: 'FR', md5Name: md5('FBA-FR'), warehouseId: 'FR', isYms: null, warehouseType: 999 },
  { warehouseName: 'DE', md5Name: md5('FBA-DE'), warehouseId: 'DE', isYms: null, warehouseType: 999 },
  { warehouseName: 'IT', md5Name: md5('FBA-IT'), warehouseId: 'IT', isYms: null, warehouseType: 999 },
  { warehouseName: 'TR', md5Name: md5('FBA-TR'), warehouseId: 'TR', isYms: null, warehouseType: 999 },
  { warehouseName: 'AE', md5Name: md5('FBA-AE'), warehouseId: 'AE', isYms: null, warehouseType: 999 },
  { warehouseName: 'IN', md5Name: md5('FBA-IN'), warehouseId: 'IN', isYms: null, warehouseType: 999 },
  { warehouseName: 'JP', md5Name: md5('FBA-JP'), warehouseId: 'JP', isYms: null, warehouseType: 999 },
  { warehouseName: 'AU', md5Name: md5('FBA-AU'), warehouseId: 'AU', isYms: null, warehouseType: 999 },
  { warehouseName: 'SG', md5Name: md5('FBA-SG'), warehouseId: 'SG', isYms: null, warehouseType: 999 },
  { warehouseName: 'SE', md5Name: md5('FBA-SE'), warehouseId: 'SE', isYms: null, warehouseType: 999 },
  { warehouseName: 'PL', md5Name: md5('FBA-PL'), warehouseId: 'PL', isYms: null, warehouseType: 999 },
  { warehouseName: 'NL', md5Name: md5('FBA-NL'), warehouseId: 'NL', isYms: null, warehouseType: 999 },
  { warehouseName: 'SA', md5Name: md5('FBA-SA'), warehouseId: 'SA', isYms: null, warehouseType: 999 },
  { warehouseName: 'BE', md5Name: md5('FBA-BE'), warehouseId: 'BE', isYms: null, warehouseType: 999 },
  { warehouseName: 'EG', md5Name: md5('FBA-EG'), warehouseId: 'EG', isYms: null, warehouseType: 999 },
  { warehouseName: 'ZA', md5Name: md5('FBA-ZA'), warehouseId: 'ZA', isYms: null, warehouseType: 999 },
  { warehouseName: 'Ural Khorgos 2', md5Name: md5('FBP-Ural Khorgos 2'), warehouseId: 'Ural Khorgos 2', isYms: null, warehouseType: 1111 },
  { warehouseName: 'Ural Hangzhou 1', md5Name: md5('FBP-Ural Hangzhou 1'), warehouseId: 'Ural Hangzhou 1', isYms: null, warehouseType: 1111 },
  { warehouseName: 'UNI Dongning 1', md5Name: md5('FBP-UNI Dongning 1'), warehouseId: 'UNI Dongning 1', isYms: null, warehouseType: 1111 },
  { warehouseName: 'Ural Dongguan 1', md5Name: md5('FBP-Ural Dongguan 1'), warehouseId: 'Ural Dongguan 1', isYms: null, warehouseType: 1111 },
  { warehouseName: 'UNI Shanghai 2', md5Name: md5('FBP-UNI Shanghai 2'), warehouseId: 'UNI Shanghai 2', isYms: null, warehouseType: 1111 },
  { warehouseName: 'CEL Hunchun 2', md5Name: md5('FBP-CEL Hunchun 2'), warehouseId: 'CEL Hunchun 2', isYms: null, warehouseType: 1111 },
];

// const tabKey = ['selfOperatedWarehouse', 'overseasdWarehouse', 'platformWarehouse'];

export default {
  mixins: [Mixin],
  components: {
    setTableColumn
  },
  props: {
    getSeatchFilter: { type: Function, default: () => {} }
  },
  data () {
    return {
      allPageStatus: false,
      tableDataLoading: false,
      exportLoading: false,
      pageLoading: false,
      allUserData: this.$store.state.userInfoList,
      productStatus: productData.productStatus,
      selfOperatedWarehouse: [],
      overseasdWarehouse: [],
      platformWarehouse: platformData,
      warehouseDataList: [],
      warehouseDataObj: {},
      wareTypeList: [],
      warehouseList: [],
      salesStatusObj: {},
      typeGroupObj: {},
      typeGroupList: [],
      tableHeadList: [],
      pageArray: [10, 20, 50, 100, 500],
      // 总记录数
      tableTotal: 0,
      // 映射列表筛选参数
      pageParams: {
        // orderBy: '',
        // upDown: 'down',
        pageNum: 1,
        pageSize: 50
      },
      tableColumnData: [
        {
          tabLabel: '自营仓',
          tabKey: 'selfOperatedWarehouse',
          required: true,
          // 替换的 key
          replaceKey: { label: 'warehouseName', value: 'warehouseId', isCheck: 'isCheck' },
          // 判断是否改变
          estimateChange: (newVal, oldVal) => {
            return JSON.stringify(newVal) != JSON.stringify(oldVal);
          },
          // 恢复默认设置
          renewData: () => {
            if (this.$common.isEmpty(this.selfOperatedWarehouse)) return [];
            let info = this.selfOperatedWarehouse.find(item => item.warehouseName == '佛山丽山仓');
            if (this.$common.isEmpty(info)) {
              info = this.selfOperatedWarehouse[0];
            }
            return [info.warehouseId];
          },
          // 对应数据
          options: [],
          // 更新选中的数据
          updateData: (data) => {
            this.selfOperatedWarehouse.forEach(item => {
              item.isCheck = data.includes(item.warehouseId);
            });
          }
        },
        {
          tabLabel: '海外仓',
          tabKey: 'overseasdWarehouse',
          required: true,
          // 替换的 key
          replaceKey: { label: 'warehouseName', value: 'warehouseId', isCheck: 'isCheck' },
          // 判断是否改变
          estimateChange: (newVal, oldVal) => {
            return JSON.stringify(newVal) != JSON.stringify(oldVal);
          },
          // 恢复默认设置
          renewData: () => {
            if (this.$common.isEmpty(this.overseasdWarehouse)) return [];
            let info = this.overseasdWarehouse.find(item => item.warehouseName == '佛山丽山仓');
            if (this.$common.isEmpty(info)) return [];
            return [info.warehouseId];
          },
          // 对应数据
          options: [],
          // 更新选中的数据
          updateData: (data) => {
            this.overseasdWarehouse.forEach(item => {
              item.isCheck = data.includes(item.warehouseId);
            });
          }
        },
        {
          tabLabel: '平台仓',
          tabKey: 'platformWarehouse',
          group: [
            { name: 'FBA', warehouseType: 999 },
            { name: 'FBP', warehouseType: 1111 },
          ],
          required: true,
          // 替换的 key
          replaceKey: { label: 'warehouseName', value: 'warehouseId', isCheck: 'isCheck' },
          // 判断是否改变
          estimateChange: (newVal, oldVal) => {
            return JSON.stringify(newVal) != JSON.stringify(oldVal);
          },
          // 恢复默认设置
          renewData: () => {
            let obj = { value: [], FBA: [], FBP: [] };
            if (this.$common.isEmpty(this.platformWarehouse)) return obj;
            let info = this.platformWarehouse.find(item => item.warehouseName == '佛山丽山仓');
            if (this.$common.isEmpty(info)) return obj;
            if (info.warehouseType == 999) {
              obj.FBA = info.warehouseId;
              obj.value = info.warehouseId;
            } else if (info.warehouseType == 1111) {
              obj.FBP = info.warehouseId;
              obj.value = info.warehouseId;
            }
            return obj;
          },
          // 对应数据
          options: [],
          // 更新选中的数据
          updateData: (data) => {
            this.platformWarehouse.forEach(item => {
              item.isCheck = data.includes(item.warehouseId);
            });
          }
        },
      ],
      // 选中的数据
      chosedTableRowData: [],
      // 列表数据
      tableData: [],
      // 列表列定义
      beforeColumn: [
        {
          title: 'SPU',
          key: 'spu',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
          render: (h, { row }) => {
            return h('div', {
              style: {
                color: '#2d8cf0',
              }
            }, `${row.spu || ''}`);
          }
        },
        {
          title: 'SKU',
          key: 'sku',
          minWidth: 140,
          align: 'center',
          fixed: 'left',
        },
        {
          title: '商品状态',
          key: 'status',
          width: 90,
          align: 'center',
          fixed: 'left',
          render: (h, { row }) => {
            let text = '';
            this.productStatus.forEach(item => {
              if (item.value == row.status) {
                text = h('span', item.label)
              }
            })
            return text;
          }
        },
        {
          title: '规格',
          key: 'specification',
          width: 140,
          align: 'center',
          fixed: 'left',
          render: (h, { row }) => {
            if (this.$common.isEmpty(row.productGoodsSpecifications)) return h('div', {}, '');
            let pos = '';
            row.productGoodsSpecifications.forEach((n, i) => {
              if (i !== row.productGoodsSpecifications.length - 1) {
                pos += n.value + '·';
              } else {
                pos += n.value;
              }
            });
            return h('div', {}, pos);
          }
        },
      ],
      tableColumns: [],
    };
  },
  watch: {},
  created () {
    let awaitRes = [
      this.getWarehouse,
    ];
    this.pageLoading = true;
    this.$common.promiseAll(awaitRes).finally(() => {
      this.initHand().finally(() => {
        // this.setEmptyTextTop();
        this.pageLoading = false;
        // this.searchTableData();
      })
    });
  },
  computed: {
    tableHeight () {
      return this.getTableHeight(286);
    },
    // 可查看的事业部
    businessDeptIds() {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return '';
      return this.$store.getters['authUserInfo'].securityUser.businessDeptIds;
    },
    // 权限
    permission () {
      return {
        // 导出
        export: this.getPermission('productGoods_exportInventory')
      }
    },
    userId () {
      if (!this.$store.getters['authUserInfo'] || !this.$store.getters['authUserInfo'].securityUser) return '';
      return this.$store.getters['authUserInfo'].securityUser.erpUserId || '';
    },
    cacheKey () {
      if (this.$common.isEmpty(this.userId)) return `${process.env.NODE_ENV}-defaultCacheTableColumnKey`;
      return `${process.env.NODE_ENV}-cacheTableColumnKey-${this.userId}`;
    },
  },
  methods: {
    // 初始化数据
    initHand () {
      return new Promise((resolve) => {
        this.salesStatusObj = {};
        this.typeGroupObj = {};
        this.typeGroupList = [md5('瑞服工厂')];
        this.tableColumns = this.$common.copy(this.beforeColumn);
        let defaultCheck = null;
        let defaultKey = null;
        let allWall = [];
        this.platformWarehouse.forEach(item => {
          this.$set(this.warehouseDataObj, item.md5Name, item);
        });
        this.tableColumnData.forEach(item => {
          allWall = [...allWall, ...(this[item.tabKey] || [])];
          let getStorageVal = window.localStorage.getItem(`${item.tabKey}-${this.cacheKey}`);
          getStorageVal = this.$common.isEmpty(getStorageVal) ? [] : JSON.parse(getStorageVal);
          (this[item.tabKey] || []).forEach(op => {
            op.isCheck = getStorageVal.includes(op[item.replaceKey.value]);
          });
          // 仓库处理
          if (['selfOperatedWarehouse', 'overseasdWarehouse', 'platformWarehouse'].includes(item.tabKey)) {
            let info = (this[item.tabKey] || []).find(f => f.isCheck);
            if (this.$common.isEmpty(info) && !this.$common.isEmpty(this[item.tabKey])) {
              (this[item.tabKey] || []).forEach(f => {
                if (f.warehouseName == '佛山丽山仓') {
                  f.isCheck = true;
                  getStorageVal = [f.warehouseId];
                  window.localStorage.setItem(`${item.tabKey}-${this.cacheKey}`, JSON.stringify(getStorageVal));
                }
              });
            }
          }
          if (this.$common.isEmpty(defaultCheck)) {
            defaultCheck = (this[item.tabKey] || []).find(f => f.isCheck);
          }
          if (this.$common.isEmpty(defaultKey) && !this.$common.isEmpty(this[item.tabKey])) {
            defaultKey = item.tabKey;
          }
          item.options = this[item.tabKey] || [];
        });
        // 当还是存在没有选中一个值时选中一个
        if (this.$common.isEmpty(defaultCheck)) {
          this[defaultKey][0].isCheck = true;
          const getStorageVal = [this[defaultKey][0].warehouseId];
          window.localStorage.setItem(`${defaultKey}-${this.cacheKey}`, JSON.stringify(getStorageVal));
        }
        (allWall || []).forEach((item) => {
          if (item.isYms == 1) {
            if (this.$common.isUndefined(this.typeGroupObj['yms'])) {
              this.$set(this.typeGroupObj, 'yms', []);
            }
            this.typeGroupObj['yms'].push(item.warehouseName);
            if (!this.typeGroupList.includes('yms')) {
              this.typeGroupList.push('yms');
            }
          } else {
            if (this.$common.isUndefined(this.typeGroupObj[item.warehouseType])) {
              this.$set(this.typeGroupObj, item.warehouseType, []);
            }
            this.typeGroupObj[item.warehouseType].push(item.warehouseName);
            if (!this.typeGroupList.includes(item.warehouseType)) {
              this.typeGroupList.push(item.warehouseType);
            }
          }
        });
        this.$nextTick(() => {
          resolve({ state: 'finally' });
        })
      })
    },
    // 获取所有仓库
    getWarehouse() {
      return new Promise((resolve) => {
        this.warehouseList = [];
        this.warehouseDataList = [];
        this.selfOperatedWarehouse = [];
        this.overseasdWarehouse = [];
        this.wareTypeList = [];
        this.warehouseDataObj = {};
        const defaultItem = { warehouseName: '瑞服工厂', md5Name: md5('瑞服工厂'), warehouseId: '瑞服工厂', isYms: null, warehouseType: 0 };
        this.$set(this.warehouseDataObj, defaultItem.md5Name, defaultItem);
        let newList = [];
        let typeList = [];
        this.axios.post(api.queryAllUserWarehouse, {}, { hiddenError: true }).then(res => {
          if (res && res.data && res.data.status === 200) {
            let selfOperatedList = [];
            let overseasdList = [];
            let platformList = [];
            this.warehouseList = this.$common.isEmpty(res.data.data) ? [] : res.data.data;
            let newItem = {};
            (this.$common.isEmpty(res.data.data) ? [] : res.data.data).forEach(item => {
              newItem = {
                ...item,
                md5Name: md5(item.warehouseName),
              };
              newList.push(newItem);
              this.$set(this.warehouseDataObj, md5(item.warehouseName), newItem);
              typeList.push(item.warehouseType);
              if (item.warehouseType == 0) {
                selfOperatedList.push(newItem);
              } else if (item.warehouseType == 1) {
                overseasdList.push(newItem);
              } else if (this.$common.isEmpty(item.warehouseType)) {
                platformList.push(newItem);
              }
            });
            this.warehouseList.unshift({ warehouseName: '全部', warehouseId: -1 });
            this.warehouseDataList = [defaultItem, ...newList];
            this.wareTypeList = this.$common.arrRemoveRepeat(typeList).sort((a, b) => {
              return a - b;
            });
            this.selfOperatedWarehouse = [defaultItem, ...selfOperatedList];
            this.overseasdWarehouse = overseasdList;
          }
        }).catch(() => {
          this.warehouseDataList = this.$common.copy([defaultItem]);
          this.selfOperatedWarehouse = [defaultItem];
        }).finally(() => {
          resolve({ state: 'finally' });
        })
      });
    },
    // 搜索参数
    skuSearchParams () {
      let param = this.getSeatchFilter();
      const removeKey = [];
      let warehouseIdList = [];
      // param.statusList = param.skuStatusList;
      // param.productCodeList = this.$common.isEmpty(param.code) ? [] : param.code.split(',');
      param.businessDeptIdList = this.businessDeptIds.split(',');
      let keyList = this.tableColumnData.map(m => m.tabKey);
      let allWall = [];
      keyList.forEach(key => {
        allWall = [...allWall, ...this[key]];
      });
      allWall.forEach(item => {
        if (item.isCheck) {
          warehouseIdList.push(item.warehouseId);
        }
      });
      param.warehouseIdList = warehouseIdList;
      removeKey.forEach(key => {
        delete param[key];
      });
      return { ...param, ...this.pageParams };
    },
    // 搜索列表数据
    searchTableData (type) {
      if (this.tableDataLoading) return;
      if (type) {
        this.pageParams.pageNum = 1;
      }
      this.tableDataLoading = true;
      this.chosedTableRowData = [];
      this.tableColumns = this.$common.copy(this.beforeColumn);
      this.$nextTick(() => {
        let searchFilter = this.skuSearchParams();
        this.axios.post(api.querySkuInventory, searchFilter).then((res) => {
          if (!res || !res.data || res.data.code != 0 || this.$common.isEmpty(res.data.datas) || this.$common.isEmpty(res.data.datas.list)) {
            this.tableData = [];
            this.tableTotal = 0;
            this.tableDataLoading = false;
            return;
          }
          // 处理仓库列
          this.tableColumns = [...this.tableColumns, ...this.handTableColumn(res.data.datas.list[0].inventoryMap || {})];
          // 处理列表数据
          let inventoryMap = {};
          let other = {};
          let newTableList = [];
          (res.data.datas.list || []).forEach(row => {
            inventoryMap = this.$common.copy(row.inventoryMap);
            Object.keys(inventoryMap).forEach(key => {
              Object.keys(inventoryMap[key]).forEach(cKey => {
                other[`${md5(key)}-${md5(cKey)}`] = inventoryMap[key][cKey];
              })
            });
            delete row.inventoryMap;
            newTableList.push({ ...row, ...other });
          });
          this.tableData = newTableList;
          this.tableTotal = res.data.datas.total || newTableList.length;
          this.$nextTick(() => {
            this.tableDataLoading = false;
            this.$emit('resizeTbale', {});
          })
        }).catch((err) => {
          console.error(err);
          this.tableData = [];
          this.tableTotal = 0;
          this.tableDataLoading = false;
        })
      })
    },
    // 分页切换
    pageChangeHand (page) {
      this.pageParams.pageNum = page;
      this.$nextTick(() => {
        this.searchTableData();
      })
    },
    // 页码改变
    pageSizeChangeHand (pageSize, plat) {
      this.pageParams.pageSize = pageSize;
      this.$nextTick(() => {
        this.searchTableData();
      })
    },
    // 选择行改变时
    choseTableDataChange (value) {
      this.chosedTableRowData = value;
    },
    // 表格列排序
    tableSortHand (data) {
      this.pageParams.orderBy = data.column.sortKey;
      this.pageParams.upDown = data.order == 'asc' ? 'up' : 'down';
      this.$nextTick(() => {
        this.searchTableData();
      })
    },
    // 更新列显示
    updataTableColumn (obj) {
      let info = {};
      let isRefreshTable = false;
      Object.keys(obj).forEach(key => {
        if (key != 'callBack') {
          if (obj[key].isChange) {
            isRefreshTable = true;
            info = this.tableColumnData.find(f => f.tabKey == key);
            if (!this.$common.isEmpty(info) && this.$common.isFunction(info.updateData)) {
              info.updateData(obj[key].data);
            }
            window.localStorage.setItem(`${key}-${this.cacheKey}`, JSON.stringify(obj[key].data));
          }
        }
      });
      this.$nextTick(() => {
        if (isRefreshTable) {
          this.searchTableData();
        }
        if (this.$common.isFunction(obj.callBack)) {
          obj.callBack();
        }
      });
    },
    // 处理仓库列方法
    handTableColumn (obj) {
      let first = '';
      let child = [];
      let childCol = [];
      let second = '';
      let typeObj = {};
      let afterList = [];
      Object.keys(obj).forEach(key => {
        first = md5(key);
        child = Object.keys(obj[key]);
        if (!this.$common.isEmpty(child)) {
          childCol = [];
          child.forEach(cKey => {
            second = md5(cKey);
            childCol.push({
              title: cKey,
              key: `${first}-${second}`,
              align: 'center',
              minWidth: 90,
            });
          });
          if (!this.$common.isEmpty(this.warehouseDataObj[first])) {
            if (this.$common.isUndefined(typeObj[this.warehouseDataObj[first].warehouseType])) {
              this.$set(typeObj, this.warehouseDataObj[first].warehouseType, []);
            }
            typeObj[this.warehouseDataObj[first].warehouseType].push({
              title: key,
              key: first,
              align: 'center',
              children: childCol
            });
          } else {
            afterList.push({
              title: key,
              key: first,
              align: 'center',
              children: childCol
            });
          }
        }
      });
      // 仓库名称和返回的仓库名称存在不一样，直接使用返回什么就展示什么仓库
      let newDataList = [];
      let middleList = [];
      let nKey = null;
      Object.keys(typeObj).forEach(key => {
        if (!this.$common.isEmpty(key)) {
          nKey = this.$common.isEmpty(Number(key)) ? key : Number(key);
          if (!this.wareTypeList.includes(nKey) && !this.$common.isEmpty(typeObj[key])) {
            middleList.push(typeObj[key]);
          }
        }
      });
      this.wareTypeList.forEach(type => {
        if (!this.$common.isEmpty(typeObj[type])) {
          newDataList.push(typeObj[type]);
        }
      });
      return [...this.$common.flat([...newDataList, ...middleList], 1), ...afterList];
    },
    // 导出操作
    exportHand (str) {
      if (this.exportLoading) return;
      let searchFilter = this.skuSearchParams();
      searchFilter.productInventoryExport = true;
      this.exportLoading = true;
      this.axios.post(api.exportSkuInventory, searchFilter).then((res) => {
        if (res && res.data && res.data.code == 0 && res.data.datas) {
          this.$Message.success(`导出操作执行成功，稍后到“导出查看”页面中查看，导出任务号：${res.data.datas}`);
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
  }
};
</script>
<style scoped lang="less">
.page-detail-main {
  .row-between-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  :deep(.ivu-table-cell) {
    .text-align-dom {
      display: inline-block;
      margin: 0 auto;
      text-align: left;
    }
    .table-td-class {
      .ivu-btn{
        margin-right: 5px;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
}
.table-page{
  margin: 0;
  .table-page-right{
    float: initial;
    margin-bottom: 0;
    padding: 0;
    text-align: right;
    .ivu-page{
      display: inline-block;
    }
  }
}
</style>
